//In react-router-dom v6, "Switch" is replaced by routes "Routes". 
import './App.css';
import Navigation from './components/Navigation';

function App() {
  return (
    <div>
      <Navigation/>
    </div>
  );
}



export default App;
